export type ButtonVariant =
  | "brand"
  | "secondary"
  | "secondaryBlackBorder"
  | "refresh"
  | "danger";

export const variantClasses: Record<ButtonVariant, string> = {
  brand: `
    bg-semantic-bg-brand-bold-secondary
    text-white
    hover:opacity-90
    active:opacity-80
  `,

  secondary: `
    bg-semantic-bg-primary
    border 
    border-solid
    border-semantic-border-secondary
    text-semantic-text-primary
    hover:bg-semantic-state-active
    active:bg-semantic-bg-primary
    shadow-sm
  `,

  secondaryBlackBorder: `
    bg-semantic-bg-primary
    border
    border-solid
    border-black
    text-semantic-text-primary
    hover:bg-semantic-state-active
    active:bg-semantic-bg-primary
    shadow-sm
  `,

  danger: `
    bg-semantic-bg-danger-secondary
    border
    border-semantic-border-secondary
    text-semantic-text-danger
    hover:bg-semantic-hover-danger
    active:bg-semantic-bg-danger-primary
    shadow-sm
  `,

  refresh: `
    bg-transparent
    text-semantic-text-primary
    hover:bg-semantic-state-active
    rounded-full
    border-none
  `,
};

/** Formas posibles de botón (filled o ghost). */
export type ButtonShape = "filled" | "ghost";
export const shapeClasses: Record<ButtonShape, string> = {
  filled: ``,
  ghost: `
      bg-transparent
      hover:bg-semantic-state-active
      border border-solid border-semantic-border-secondary
    `,
};

/** Tamaños de botón. */
export type ButtonSize = "sm" | "md" | "lg";
export const sizeClasses: Record<ButtonSize, string> = {
  sm: "h-8 px-2 gap-1 text-sm",
  md: "py-1.5 px-3 gap-2 text-sm",
  lg: "h-12 px-4 gap-2 text-base",
};
